import PropTypes from 'prop-types';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';

import * as Styled from '../../ProductCard.style';

function CardButton({
  clicksreamProps, modalName, onClick, title
}) {
  const handleButtonPressed = useButtonPressedCallback(clicksreamProps);

  const handleClick = () => {
    handleButtonPressed();

    if (onClick && typeof onClick === 'function') {
      onClick(modalName);
    }
  };

  return (
    <Styled.FauxButton
      aria-label={title}
      onClick={handleClick}
    />
  );
}

CardButton.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  clicksreamProps: PropTypes.object,
  onClick: PropTypes.func,
  modalName: PropTypes.string,
  title: PropTypes.string.isRequired
};
export default CardButton;
